// src/theme/useTheme.js
import { useEffect, useState, useCallback } from "react";
import { setThemeVars, setDarkClass } from "./setThemeVars";
import { getSettings, getPublicColors } from "../services/settingsServices";

const LS_KEY = "mairie-theme";

export default function useTheme() {
  const [loading, setLoading] = useState(true);
  const [primary, setPrimary] = useState("#007AC9");
  const [secondary, setSecondary] = useState("#FB923C");
  const [btn1, setBtn1] = useState("#007AC9");
  const [btn2, setBtn2] = useState("#4BABE9");
  const [dark, setDark] = useState(false);

  useEffect(() => {
    (async () => {
      const saved = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
      const hasToken = !!localStorage.getItem("token");
      const s = hasToken ? await getSettings() : await getPublicColors();

      const p = saved.primary || s?.primary_color || "#007AC9";
      const s2 = saved.secondary || s?.primary_color2 || "#FB923C";
      const b1 = saved.btn1 || s?.button_primary_color || p;
      const b2 = saved.btn2 || s?.button_primary_color2 || b1;
      const d = saved.dark ?? false;

      setPrimary(p); setSecondary(s2); setBtn1(b1); setBtn2(b2); setDark(d);
      setThemeVars(p, s2, b1, b2);
      setDarkClass(d);
      setLoading(false);
    })();
  }, []);

  const persist = (obj) => {
    const cur = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
    localStorage.setItem(LS_KEY, JSON.stringify({ ...cur, ...obj }));
  };

  const applyPrimary = useCallback((hex) => {
    setPrimary(hex); setThemeVars(hex, secondary, btn1, btn2);
    persist({ primary: hex });
  }, [secondary, btn1, btn2]);

  const applySecondary = useCallback((hex) => {
    setSecondary(hex); setThemeVars(primary, hex, btn1, btn2);
    persist({ secondary: hex });
  }, [primary, btn1, btn2]);

  const applyBtn1 = useCallback((hex) => {
    setBtn1(hex); setThemeVars(primary, secondary, hex, btn2);
    persist({ btn1: hex });
  }, [primary, secondary, btn2]);

  const applyBtn2 = useCallback((hex) => {
    setBtn2(hex); setThemeVars(primary, secondary, btn1, hex);
    persist({ btn2: hex });
  }, [primary, secondary, btn1]);

  const toggleDark = useCallback(() => {
    setDark((v) => {
      const next = !v; setDarkClass(next); persist({ dark: next }); return next;
    });
  }, []);

  return {
    loading, primary, secondary, btn1, btn2, dark,
    applyPrimary, applySecondary, applyBtn1, applyBtn2, toggleDark,
  };
}
